module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Gym_D4_cam5.deffb1de.jpg";